import React from "react";

import { Radio } from "clearsense-ui/components";

const Source = ({ handleChangeType, existingOrNew }) => (
  <Radio stacked className="space-y-4">
    <Radio.Item
      onChange={() => {
        handleChangeType("existing");
      }}
      checked={existingOrNew === "existing"}
      label="Choose from existing sources"
      value="existing"
      name="application"
      data-cy="add-existing-source-radio"
    />
    <Radio.Item
      onChange={() => {
        handleChangeType("new");
      }}
      checked={existingOrNew === "new"}
      label="Create a new source"
      value="new"
      name="application"
      data-cy="add-new-source-radio"
    />
  </Radio>
);

export default Source;
